import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

interface IssueSubmittedDialogProps {
  open: boolean;
  onClose: () => void;
  issueNumber: string;
}

export function IssueSubmittedDialog({ open, onClose, issueNumber }: IssueSubmittedDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            Issue Submitted Successfully
          </DialogTitle>
          <Button
            variant="ghost"
            className="absolute right-4 top-4 rounded-sm opacity-70 hover:opacity-100"
            onClick={onClose}
          >
            <X className="h-4 w-4" />
          </Button>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <DialogDescription>
            Your issue has been submitted successfully. Please save your issue number for future reference.
          </DialogDescription>
          <div className="flex items-center justify-center">
            <code className="px-4 py-2 bg-zinc-100 rounded-lg text-lg font-mono font-semibold">
              #{issueNumber}
            </code>
          </div>
          <p className="text-sm text-muted-foreground text-center">
            You can use this number to track the status of your issue at any time.
          </p>
        </div>
        <DialogFooter className="sm:justify-center">
          <Button onClick={onClose}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}